import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import Immersive3dTourReplacePanoramaProcessRepository from "~/repository/Immersive3dTour/Immersive3dTourReplacePanoramaProcessRepository";

class Immersive3dTourReplacePanoramaProcessStore extends NestStore {
  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {Immersive3dTourReplacePanoramaProcessRepository|null}
   */
  immersive3dTourReplacePanoramaProcessRepository = null;

  constructor() {
    super();

    this.immersive3dTourReplacePanoramaProcessRepository = new Immersive3dTourReplacePanoramaProcessRepository();
  }

  @action
  update(data) {
    this.isLoading = true;

    return this.immersive3dTourReplacePanoramaProcessRepository
      .update(this.tourId, data)
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

export default Immersive3dTourReplacePanoramaProcessStore;
